import { NumberWithUnit, NumberWithUnitConstructor, UnitSource } from "./NumberWithUnit";
import { Unit } from "./Unit";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";
import { WeightConversionFactors } from "./WeightConversionFactors";
import { WeightUnits } from "./WeightUnits";

export class Weight extends NumberWithUnit {
    protected override get cls(): NumberWithUnitConstructor {
        return Weight;
    }

    public override get unitGroup(): WeightUnits {
        return WeightUnits.singleton;
    }

    public override convert(targetUnit: UnitSource): number {
        const targetUnitAbbreviation = Unit.resolveAbbreviation(targetUnit);
        return this.convertWithPrecision(targetUnitAbbreviation, 2);
    }

    public override getConversionFactors(): UnitConversionFactorGroup {
        return WeightConversionFactors.get();
    }
}
